import { MESApiService, type spParameter } from "@dexteel/mesf-core";
import type { EmailRecipient } from "../models/EmailRecipient";

export const getEmailRecipients = async () => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [];

	return await apiService.callV2("[MMS].[GetEmailRecipients]", parameters);
};

export const upsertEmailRecipient = async (data: EmailRecipient) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "RecipientId", value: data.RecipientId },
		{ name: "DisplayName", value: data.DisplayName },
		{ name: "EmailAddress", value: data.EmailAddress },
		{ name: "IsActive", value: !!data.IsActive },
	];

	return await apiService.callV2("[MMS].[UpsertEmailRecipient]", parameters);
};

export const deleteEmailRecipient = async (recipientId: number) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "RecipientId", value: recipientId },
	];

	return await apiService.callV2("[MMS].[DeleteEmailRecipient]", parameters);
};

/** The address book with a tick on the ones this template already notifies. */
export const getTemplateRecipients = async (templateId: number | null) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [{ name: "TemplateId", value: templateId }];

	return await apiService.callV2("[MMS].[GetTemplateRecipients]", parameters);
};

/** Saves the FINAL set of ticks; the procedure works out what to add and what to remove. */
export const setTemplateRecipients = async (
	templateId: number,
	recipientIds: number[],
) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "TemplateId", value: templateId },
		{ name: "RecipientIdsCSV", value: recipientIds.join(",") },
	];

	return await apiService.callV2("[MMS].[SetTemplateRecipients]", parameters);
};
